import { Navigate } from "react-router-dom";
import App from "../app.jsx";
import Dashboard from "../pages/dashboard/dashboard.js";
import PagesError from "../pages/pages/error.js";
import LoginPage from "../auth/pages/LoginPage.jsx";
import ProtectedRoute from "../auth/components/ProtectedRoute.js";
import EventsScreen from "../pages/pages/events/events.js";
import Users from "../pages/pages/users/users.js";

const AppRoute = [
	{
		path: "",
		element: <App />,
		children: [
			{ path: "login", element: <LoginPage /> },
			{ path: "/", element: <Navigate to="/login" /> },
			{
				path: "/*",
				element: <ProtectedRoute />,
				children: [
					{
						path: "dashboard",
						element: <Dashboard />,
					},
					{
						path: "users",
						element: <Users />,
					},
					{
						path: "events",
						element: <EventsScreen />,
					},
					{ path: "*", element: <PagesError /> },
				],
			},
		],
	},
];

export default AppRoute;
